import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import { environment } from "../../environment";
export const NavbarNew = () => {
  const [fname, setFname] = useState("");
  useEffect(() => {
    let uid = JSON.parse(localStorage.getItem("user"))._id;
    // console.log(Fname);
    axios
      .get(environment.dap_url + "users/getUserById?id=" + uid)
      .then((resp) => {
        let user = resp.data.note;
        console.log("navbar", resp.data);
        let user_name = user.userFirstName;
        setFname(user_name);
      });
  });

  return (
    <div class="app-main__inner">
      <div class="row welcome-drop">
        <div class="col-lg-4 col-12">
          <h2 class="wlcm-head">
            Welcome <span>{fname}!</span>
          </h2>
        </div>
      </div>
    </div>
  );
};
export default NavbarNew;
